import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../translations/translations';

const FAQSection = () => {
  const { language } = useLanguage();
  const faqs = [
    {
      questionKey: "faqSection.q1",
      answerKey: "faqSection.a1"
    },
    {
      questionKey: "faqSection.q2",
      answerKey: "faqSection.a2"
    },
    {
      questionKey: "faqSection.q3",
      answerKey: "faqSection.a3"
    },
    {
      questionKey: "faqSection.q4",
      answerKey: "faqSection.a4"
    },
    {
      questionKey: "faqSection.q5",
      answerKey: "faqSection.a5"
    },
    {
      questionKey: "faqSection.q6",
      answerKey: "faqSection.a6"
    },
    {
      questionKey: "faqSection.q7",
      answerKey: "faqSection.a7"
    },
    {
      questionKey: "faqSection.q8",
      answerKey: "faqSection.a8"
    }
  ];

  return (
    <section className="section-padding faq-section" id="faq">
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          <h2>{getTranslation(language, 'faqSection.title')}</h2>
          <p>
            {getTranslation(language, 'faqSection.subtitle')}
          </p>
        </div>
        
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="accordion accordion-custom" id="faqAccordion" data-aos="fade-up">
              {faqs.map((faq, index) => (
                <div className="accordion-item" key={index}>
                  <h2 className="accordion-header" id={`faq-heading-${index}`}>
                    <button 
                      className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                      type="button" 
                      data-bs-toggle="collapse" 
                      data-bs-target={`#faq-collapse-${index}`}
                      aria-expanded={index === 0 ? 'true' : 'false'}
                      aria-controls={`faq-collapse-${index}`}
                    >
                      {getTranslation(language, faq.questionKey)}
                    </button>
                  </h2>
                  <div 
                    id={`faq-collapse-${index}`}
                    className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                    aria-labelledby={`faq-heading-${index}`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      {getTranslation(language, faq.answerKey)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
